import React from 'react';
import classnames from 'classnames';
import { Button, ButtonProps } from 'tea-component';

import './index.scss';

interface IOperationBtnsProps extends IBaseProps {
  isShowAdd?: boolean;
  isShowDelete?: boolean;
  btnType?: ButtonProps['type'];
  htmlType?: ButtonProps['htmlType'];
  onAdd?: () => void;
  onDelete?: () => void;
}

const OperationBtns: React.FC<IOperationBtnsProps> = (props) => {
  const {
    style,
    className,
    isShowAdd = false,
    isShowDelete = false,
    btnType = 'text',
    htmlType = 'button',
    onAdd,
    onDelete,
  } = props;

  return (
    <div style={style} className={classnames('dbg-operation-btns', className)}>
      {isShowDelete && (
        <Button
          type={btnType}
          htmlType={htmlType}
          style={{ marginRight: 10 }}
          onClick={(e) => {
            e?.stopPropagation();
            onDelete?.();
          }}
        >
          Delete
        </Button>
      )}
      {isShowAdd && (
        <Button
          type={btnType}
          htmlType={htmlType}
          onClick={(e) => {
            e?.stopPropagation();
            onAdd?.();
          }}
        >
          Add
        </Button>
      )}
    </div>
  );
};

export default OperationBtns;
